<template>
  <!-- Mobile Slide-up Modal -->
  <div v-if="isMobile && isVisible" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end">
    <div class="w-full bg-[#ABBCF4] rounded-t-3xl transform transition-transform duration-300 ease-out"
         :class="isVisible ? 'translate-y-0' : 'translate-y-full'">
      <!-- Close Button -->
      <button
        @click="closePopup"
        class="absolute top-4 right-4 w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all z-10"
      >
        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>

      <!-- Flight Content -->
      <div class="p-6 pt-12 pb-8 flex flex-col items-center justify-center min-h-[400px]">
        <div class="text-center">
          <img src="/plane.png" alt="Plane" class="h-20 w-20 mx-auto mb-6 opacity-80" />
          <h2 class="text-3xl font-bold text-white mb-4">Flight Search</h2>
          <p class="text-lg font-medium text-white mb-6">Get the best pricing for your next adventure!</p>
          <button
            @click="handleSearchFlights"
            class="w-full bg-blue-500 text-white px-12 py-3 rounded-3xl hover:bg-blue-600 transition-colors font-medium"
          >
            Search Flights
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Desktop/Inline Mode -->
  <div v-else-if="isInline || (!isMobile && isVisible)"
       class="h-full bg-[#ABBCF4] rounded-3xl overflow-hidden">
    <!-- Flight Content -->
    <div class="h-full bg-[#ABBCF4] rounded-3xl p-6 flex flex-col items-center justify-center">
      <div class="text-center">
        <img src="/plane.png" alt="Plane" class="h-20 w-20 mx-auto mb-6 opacity-80" />
        <h2 class="text-3xl font-bold text-white mb-4">Flight Search</h2>
        <p class="text-lg font-medium text-white mb-6">Get the best pricing for your next adventure!</p>
        <button
          @click="handleSearchFlights"
          class="w-full bg-blue-500 text-white px-12 py-3 rounded-3xl hover:bg-blue-600 transition-colors font-medium"
        >
          Search Flights
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlightSearchPopup',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    isInline: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  emits: ['search-flights', 'close'],
  methods: {
    handleSearchFlights() {
      // Emit event to show coming soon modal (matching desktop behavior)
      this.$emit('search-flights');
    },
    closePopup() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
/* Smooth transitions */
* {
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;
}
</style>
